import styled from "styled-components/macro";
import recycleCard from "../../Images/recycle-card.png";
import bottlesCard from "../../Images/bottles-card.png";
export const CardWrapper = styled.div`
  padding: 1.5rem 1rem;
  max-width: 20rem;
  @media screen and (max-width: 520px) {
    max-width: unset;
    width: 100%;
  }
  background: ${(props) => `url(${props.bg})`};
  min-height: 25rem;
  p {
    text-align: center;
    line-height: 1.9;
  }
  p {
    color: #030303;
    opacity: 75%;
  }
  h4 {
    text-align: center;
  }
`;
export const CardHeading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;

  path {
    fill: #08b21c;
  }

  h4 {
    font-size: 1.2rem;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  place-items: center;
  gap: 2rem;
`;
